const awsCognitoConfig = {
  aws_cognito_identity_pool_id: "ap-southeast-2:fdd9b7d4-20cd-4d72-b3d6-fda455dffa80",
  aws_cognito_region: "ap-southeast-2",
  aws_user_pools_id: "ap-southeast-2_jK3xA2WPw",
  aws_user_pools_web_client_id: "1oh5fpnokfclcml21arbjiml5u",
  oauth: {},
};

export default awsCognitoConfig;
